export default __webpack_public_path__ + "static/pageBackground-0b2333d3fc1bb6432dced3d00348bb14.webp";